export default __webpack_public_path__ + "static/media/27.9aba12c8.jpg";